import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthProvider from './context/AuthProvider';
import StudentAuthProvider from './context/StudentAuthProvider';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import AdminRoutes from './routes/AdminRoutes';
import TeacherRoutes from './routes/TeacherRoutes';
import StudentRoutes from './routes/StudentRoutes';
import LandingPage from './components/Home/LandingPage';

function App() {
  // Sayfa başlığını ayarla
  useEffect(() => {
    document.title = 'Özel Ders';
  }, []);
  return (
    <SiteSettingsProvider>
      <Router>
        <Routes>
          {/* Ana sayfa */}
          <Route path="/" element={<LandingPage />} />

          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/teacher/*" element={
            <AuthProvider>
              <TeacherRoutes />
            </AuthProvider>
          } />
          <Route path="/student/*" element={
            <StudentAuthProvider>
              <StudentRoutes />
            </StudentAuthProvider>
          } />
        </Routes>
      </Router>
    </SiteSettingsProvider>
  );
}

export default App;